/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { Button } from "@material-ui/core";
import VideoPlayer from "react-video-js-player";
import principal from "../img/3d/illusprincipal.png";
import principal2 from "../img/3d/illusprincipal2.png";
import agency from "./../img/video/agency.mp4";
import poster from "./../img/video/p.jpg";
import { HashLink as Link } from "react-router-hash-link";
import { ArrowDownward, LocationOn, Email, Phone } from "@material-ui/icons";

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      actions: "",
    };
  }

  onMove = (text) => {
    this.setState({ actions: text });
    setTimeout(() => {
      this.setState({ actions: "" });
    }, 6000);
  };

  setAction = (text) => {
    this.setState({ actions: text });
  };

  render() {
    let withVideo = 246;
    let heigthVideo = 140;
    if (window.screen.width > 1400 && window.screen.width < 1500)
      withVideo = 246;
    if (window.screen.width > 1200 && window.screen.width < 1399)
      withVideo = 250;
    if (window.screen.width > 1100 && window.screen.width < 1199) {
      withVideo = 225;
      heigthVideo = 130;
    }
    if (window.screen.width > 960 && window.screen.width < 1099) {
      withVideo = 210;
      heigthVideo = 120;
    }
    return (
      <div className="header">
        <div className="head__illus">
          <img src={principal} alt="ecommerce" className="img-fluid"></img>
        </div>
        <div className="head__text">
          <div className="text__name">
              <h1>
                Agencia de <br className="divesp" />
                Marketing Digital <br />& Desarrollo Web
              </h1>
          </div>
          <div className="text__title">
              <h1>Impulsamos tu emprendimiento</h1>
          </div>
          <div className="head__illus2">
            <img src={principal2} alt="ecommerce" className="img-fluid"></img>
          </div>
          <div className="text__video">
            <div className="video__video">
              <VideoPlayer
                src={agency}
                poster={poster}
                height={heigthVideo}
                width={withVideo}
                className="video"
              />
            </div>
            <div className="video__actions">
              <div className="actions_info">
                <LocationOn
                  className="location icon"
                  onPointerMove={() => this.onMove("Quito - Ecuador")}
                  onClick={() => this.setAction("Quito - Ecuador")}
                />
                <Email
                  className="mail icon"
                  onPointerMove={() => this.onMove("timelabec@gmail.com")}
                  onClick={() => this.setAction("timelabec@gmail.com")}
                />
                <Phone
                  className="phone icon"
                  onPointerMove={() => this.onMove("0963395950")}
                  onClick={() => this.setAction("0963395950")}
                />
              </div>
              <h3>{this.state.actions}</h3>
              <Button
                variant="contained"
                color="secondary"
                disableElevation
                className="actions_btn"
                component={Link}
                to="/services"
              >
                <ArrowDownward
                  style={{
                    marginRight: "7px",
                    fontSize: "20px",
                    fontWeight: "bolder",
                  }}
                />
                Leer más
              </Button>
            </div>
          </div>
          <div className="head__marquee">
            <h2>
              Branding empresarial - Comercio elecrtrónico - Campañas
              publicitarias - Comunidades online
            </h2>
          </div>
        </div>
      </div>
    );
  }
}

export default Header;
